export default "__VITE_ASSET__Cn8SYTJ9__"